import "./styles.scss";
import React, {useState} from "react";
// import Lottie from "lottie-react";
// import MapJson from '../../assets/images/lottieViews/map.json';
import AppConfig from "../../helpers/config";
import {useNavigate/*, useLocation*/} from "react-router-dom";
import SignInModal from "../Modals/SignInModal";
import SignUpModal from "../Modals/SignUpModal";
import Dropdown from "react-bootstrap/Dropdown";
import SuccessModal from "../Modals/SuccessModal";
import {useDispatch, useSelector} from "react-redux";
import SunIcon from "../../assets/images/icons/Sun.svg";
// import GeniusMobile from "../../assets/images/chat-page-app-icon.svg";
import Genius from "../../assets/images/burger-menu.svg";
import Logo from "../../assets/images/logo-main-36h.svg";
import LogoDark from '../../assets/images/icons/logo-main-dark.svg';
import Android from "../../assets/images/Google-appstore.png";
import Apple from "../../assets/images/Apple-appstore.png";
import GlobeIcon from "../../assets/images/icons/icons-Globe-Line.svg";
// import BetaIcon from "../../assets/images/icons/Public-Beta.svg";

import {
    getLoginConfig,
    setIsLogin,
    setLoginUser,
    setDarkMode,
    changeAppLocale, changeAppCurrency,
} from "../../redux/slices/loginconfigSlice";
import {
    getAppConfig,
    setModals,
} from "../../redux/slices/appconfigSlice";
import {
    getCurrencyBadge,
    getCurrencyName,
} from "../../helpers/common";
import ForgotPasswordModal from "../Modals/ForgotPasswordModal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMoon, faTimes} from "@fortawesome/pro-light-svg-icons";
import {getAppTranslations} from "../../redux/slices/appTranslationSlice";
import useTranslationCustom from "../../i18n/customHook/useTranslation";
import PropTypes from "prop-types";
import { faCircleQuestion, faEnvelope, faHeart, faNewspaper, faUser } from "@fortawesome/free-regular-svg-icons";
import { faBriefcase, faCircleInfo, faGear, faRightToBracket } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

const AppHeader = () => {
    const {T} = useTranslationCustom();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const location = useLocation();
    const appConfig = useSelector(getAppConfig);
    // const searchfilters = useSelector(getSearchFilters);
    const loginconfig = useSelector(getLoginConfig);
    const appTranslations = useSelector(getAppTranslations);

    const {modals} = appConfig;
    const [showMenu, setShowMenu] = useState(false);
    const [showForgotModal, setShowForgotModal] = useState(false);

    const showMenuFun = () => setShowMenu(true);
    const hideMenu = () => setShowMenu(false);

    const browserLang = navigator.language;
    const browserCountry = browserLang.split('-')[1] || '';

    const handleHideModal = (type) =>
        dispatch(setModals({...modals, [type]: false}));
    const handleShowModal = (type) =>
        dispatch(setModals({...modals, [type]: true}));

    const darkModeHandler = () => {
        dispatch(setDarkMode(!loginconfig.darkMode));
    };

    const handleLogout = () => {
        dispatch(setIsLogin(false));
        dispatch(setLoginUser({}));
        localStorage.removeItem("auth_token");
        toast.success(T("Toasts:Toast_Description_Logout_Successfully"));
    };

    // const handleClickOnLogo = () => {
    //     if (location.pathname === "/") {
    //         // window.location.reload();
    //     } else {
    //         navigate("/");
    //     }
    // }

    const handleContactEmail = () => {
        const email = "travel@geniustravel.com";
        let clientOpened = false;
        // A real mail client grabs focus / hides the tab when mailto: fires,
        // so we can detect whether it actually did anything.
        const markOpened = () => {
            clientOpened = true;
        };
        window.addEventListener("blur", markOpened);
        document.addEventListener("visibilitychange", markOpened);

        // Try the native mail client first (no blank tab).
        window.location.href = `mailto:${email}`;

        // No client responded => fall back to Gmail web compose.
        window.setTimeout(() => {
            window.removeEventListener("blur", markOpened);
            document.removeEventListener("visibilitychange", markOpened);

            if (clientOpened || document.hidden) return;

            const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}`;
            window.open(gmailComposeUrl, "_blank", "noopener,noreferrer");
        }, 800);
    };

    return (
        <>
            <header id="header" className="header-for-desktop">
                <nav className="navbar">
                    <div className="container">
                        <a className="navbar-brand" onClick={() => navigate("/")}>
                            <img src={Logo} alt="Logo"/>
                        </a>
                        <a className="menu-toggler">
                            <span className="bar1"></span>
                            <span className="bar2"></span>
                            <span className="bar3"></span>
                        </a>
                        <div className="custom-menu">
                            {/*<div className="discover-dropdown">*/}
                            {/*    <Dropdown>*/}
                            {/*        <Dropdown.Toggle>{T("Home:Home_Discover")}</Dropdown.Toggle>*/}
                            {/*        <Dropdown.Menu>*/}
                            {/*            {appConfig?.packageTypes?.map((_package, index) => {*/}
                            {/*                return (*/}
                            {/*                    <Dropdown.Item*/}
                            {/*                        key={index}*/}
                            {/*                        onClick={() => navigateToSearchPage(_package)}*/}
                            {/*                        active={*/}
                            {/*                            _package?.guid ===*/}
                            {/*                            searchfilters?.selectedPackage?.guid*/}
                            {/*                        }*/}
                            {/*                    >*/}
                            {/*                        {_package?.type?.replace('*', ' ⭐')}*/}
                            {/*                    </Dropdown.Item>*/}
                            {/*                );*/}
                            {/*            })}*/}
                            {/*        </Dropdown.Menu>*/}
                            {/*    </Dropdown>*/}
                            {/*</div>*/}
                            <ul className="menu-items">
                                <li>
                                    <a
                                        className="menu-link"
                                        onClick={() => navigate('/')}
                                    >
                                        {T("Home:Home_Heading")}
                                    </a>
                                </li>
                                {/* <li>
                                    <a
                                        className="menu-link"
                                        onClick={() => navigate('/about-us')}
                                    >
                                        {T("Home:Home_About")}
                                    </a>
                                </li> */}
                                <li>
                                    <a className="menu-link dark-light-btn" onClick={darkModeHandler}>
                                        {loginconfig.darkMode ? (
                                            <img src={SunIcon} className="icon" alt={"sun-icon"}/>
                                        ) : (
                                            <FontAwesomeIcon className="icon" icon={faMoon}/>
                                        )}
                                        {loginconfig.darkMode ? T("Home:Home_Light_Mode") : T("Home:Home_Dark_Mode")}
                                    </a>
                                </li>
                                <li className="language-dropdown">
                                    <Dropdown>
                                        <Dropdown.Toggle>
                                            <img
                                                src={GlobeIcon}
                                                className="icon"
                                                alt={"globe-icon"}
                                            />
                                            {loginconfig?.locale?.country}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu onChange={(e) => console.log(e)}>
                                            <h6>{T("Home:Home_Language")}</h6>
                                            {appTranslations?.locales.map((language, index) => {
                                                return (
                                                    <Dropdown.Item
                                                        key={index}
                                                        onClick={() =>
                                                            dispatch(changeAppLocale(language))
                                                        }
                                                        active={language?.id === loginconfig.locale.id}
                                                    >
                                                        {language?.country}
                                                    </Dropdown.Item>
                                                );
                                            })}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </li>
                                <li className="language-dropdown">
                                    <Dropdown>
                                        <Dropdown.Toggle>
                                              <span style={{color: "#BDC6D7"}}>
                                                {getCurrencyBadge(loginconfig?.currency?.code)}
                                              </span>{" "}
                                            {loginconfig?.currency?.code}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <h6>{T("Home:Home_Currency")}</h6>
                                            {AppConfig.currencies.map((currency, index) => {
                                                return (
                                                    <Dropdown.Item
                                                        key={index}
                                                        onClick={() => dispatch(changeAppCurrency(currency))}
                                                        active={currency?.code === loginconfig?.currency?.code}
                                                    >
                                                        {`${currency?.symbol} ${currency?.name?.toUpperCase()}`}
                                                    </Dropdown.Item>
                                                );
                                            })}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </li>
                                <li className="user-dropdown">
                                    <Dropdown>
                                        <Dropdown.Toggle>
                                            <img src={Genius} alt={"genius"}/>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => navigate("/me/favorites")}>
                                                {T("Home:Home_My_Favourites")}
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={() => navigate("/me/settings")}>
                                                {T("Home:Home_Settings")}
                                            </Dropdown.Item>
                                            <Dropdown.Item className="btn-holder">
                                                <div className="auth-action">
                                                    <a
                                                        onClick={() =>
                                                            loginconfig.isLogin
                                                                ? navigate("/me/account")
                                                                : handleShowModal("register")
                                                        }
                                                    >
                                                        {T("Buttons:Account")}
                                                    </a>
                                                </div>
                                                <div className="auth-action">
                                                    <a
                                                        className="transparent-btn"
                                                        onClick={() =>
                                                            loginconfig.isLogin
                                                                ? handleLogout()
                                                                : handleShowModal("login")
                                                        }
                                                    >
                                                        {loginconfig?.isLogin ? T("Buttons:Logout") : T("Buttons:Login")}
                                                    </a>
                                                </div>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>
            <header id="header" className="header-for-mobile">
                <nav className="navbar">
                    <div className="container">
                        <a className="navbar-brand" onClick={() => navigate("/")}>
                            <img src={LogoDark} alt="Logo"/>
                        </a>
                        <div
                            className={
                                showMenu ? "custom-menu-small show" : "custom-menu-small"
                            }
                        >
                            <a onClick={hideMenu} className="close-menu">
                                <FontAwesomeIcon icon={faTimes}/>
                            </a>
                            <ul className="menu-items">
                                {/*<li className="discover-dropdown">*/}
                                {/*    <Dropdown>*/}
                                {/*        <Dropdown.Toggle>{T("Home:Home_Discover")}</Dropdown.Toggle>*/}
                                {/*        <Dropdown.Menu>*/}
                                {/*            {appConfig?.packageTypes?.map((_package, index) => {*/}
                                {/*                return (*/}
                                {/*                    <Dropdown.Item*/}
                                {/*                        key={index}*/}
                                {/*                        onClick={() => navigateToSearchPage(_package)}*/}
                                {/*                        active={*/}
                                {/*                            _package?.guid ===*/}
                                {/*                            searchfilters?.selectedPackage?.guid*/}
                                {/*                        }*/}
                                {/*                    >*/}
                                {/*                        {_package?.type?.replace('*', ' ⭐')}*/}
                                {/*                    </Dropdown.Item>*/}
                                {/*                );*/}
                                {/*            })}*/}
                                {/*        </Dropdown.Menu>*/}
                                {/*    </Dropdown>*/}
                                {/*</li>*/}
                                <li>
                                    <button
                                        className="menu-link text-start"
                                        onClick={() => {
                                            hideMenu();
                                            loginconfig.isLogin
                                                ? handleLogout()
                                                : handleShowModal("login")
                                        }}
                                    >
                                        <FontAwesomeIcon className="icon" icon={faRightToBracket} />
                                        {loginconfig?.isLogin ? T("Buttons:Logout") : T("Buttons:Login")}
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="menu-link text-start"
                                        onClick={() => {
                                            hideMenu();
                                            loginconfig.isLogin
                                                ? navigate("/me/account")
                                                : handleShowModal("register")
                                            }}
                                        >
                                            <FontAwesomeIcon className="icon" icon={faUser} />
                                            {T("Buttons:Account")}
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="menu-link text-start"
                                        onClick={() => {
                                            hideMenu();
                                            navigate("/me/favorites");
                                        }}
                                    >
                                        <FontAwesomeIcon className="icon" icon={faHeart} />
                                        {T("Home:Home_My_Favourites")}
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="menu-link text-start"
                                        onClick={() => {
                                            hideMenu();
                                            navigate("/me/settings");
                                        }}
                                    >
                                        <FontAwesomeIcon className="icon" icon={faGear} />
                                        {T("Home:Home_Settings")}
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="menu-link text-start"
                                        onClick={() => {
                                            hideMenu();
                                            navigate('/faqs');
                                        }}
                                    >
                                        <FontAwesomeIcon className="icon" icon={faCircleQuestion} />
                                        {T("Filters:Footer_Faq")}
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="menu-link text-start"
                                        onClick={() => {
                                            hideMenu();
                                            handleContactEmail();
                                        }}
                                    >
                                        <FontAwesomeIcon className="icon" icon={faEnvelope} />
                                        {T("Filters:Footer_Contact")}
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="menu-link text-start"
                                        onClick={() => {
                                            hideMenu();
                                            navigate('/about-us');
                                        }}
                                    >
                                        <FontAwesomeIcon className="icon" icon={faCircleInfo} />
                                        {T("Filters:Footer_About_Us")}
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="menu-link text-start"
                                        onClick={() => {
                                            hideMenu();
                                            navigate('/press');
                                        }}
                                    >
                                        <FontAwesomeIcon className="icon" icon={faNewspaper} />
                                        {T("Filters:Footer_Press")}
                                    </button>
                                </li>
                                <li>
                                    <button
                                        className="menu-link text-start"
                                        onClick={() => {
                                            hideMenu();
                                            navigate('/vacancies');
                                        }}
                                    >
                                        <FontAwesomeIcon className="icon" icon={faBriefcase} />
                                        {T("Filters:Footer_Vacancies")}
                                    </button>
                                </li>
                                
                                
                            </ul>
                            <div>
                            <div className="small-header-action">
                                <div className="language-dropdown action-holder">
                                    <Dropdown>
                                        <Dropdown.Toggle>
                                            <img src={GlobeIcon} className="icon" alt={"glob-icon"}/>
                                            {loginconfig?.locale?.country}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu onChange={(e) => console.log(e)}>
                                            {appTranslations?.locales.map((language, index) => {
                                                return (
                                                    <Dropdown.Item
                                                        key={index}
                                                        onClick={() =>
                                                            dispatch(changeAppLocale(language))
                                                        }
                                                        active={language?.id === loginconfig.locale.id}
                                                    >
                                                        {language?.country}
                                                    </Dropdown.Item>
                                                );
                                            })}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className="currancy-dropdown action-holder">
                                    <Dropdown>
                                        <Dropdown.Toggle>
                                            <span>
                                                {getCurrencyBadge(loginconfig?.currency?.code)}
                                            </span>
                                            {getCurrencyName(loginconfig?.currency?.code)}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {AppConfig.currencies.map((currency, index) => {
                                                return (
                                                    <Dropdown.Item
                                                        key={index}
                                                        onClick={() => dispatch(changeAppCurrency(currency))}
                                                        active={currency?.code === loginconfig?.currency?.code}
                                                    >
                                                        {`${currency?.symbol} ${currency?.name?.toUpperCase()}`}
                                                    </Dropdown.Item>
                                                );
                                            })}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className="action-holder">
                                    <a className="darkMode-btn" onClick={darkModeHandler}>
                                        {loginconfig.darkMode ? (
                                            <img src={SunIcon} className="icon" alt={"sun-icon"}/>
                                        ) : (
                                            <FontAwesomeIcon icon={faMoon} className="icon"/>
                                        )}
                                        {loginconfig.darkMode ? T("Home:Home_Light_Mode") : T("Home:Home_Dark_Mode")}
                                    </a>
                                </div>
                            </div>
                            <div className="download-app">
                                <a
                                    href={AppConfig.AndroidPlayStoreLink}
                                    target={"_blank"}
                                    rel="noopener noreferrer"
                                >
                                    <img src={Android} alt={"android-picture"}/>
                                </a>
                                <a
                                    href={AppConfig.iOSAppStoreLink}
                                    target={"_blank"}
                                    rel="noopener noreferrer"
                                >
                                    <img src={Apple} alt={"apple-picture"}/>
                                </a>
                            </div>
                            <ul className="static-pages-link">
                                <li>
                                    <a onClick={() => navigate(`/privacy-policy/query?locale=${loginconfig?.locale?.code}&external=false`)}>
                                        {T("Filters:Footer_Privacy_Policy")}
                                    </a>
                                </li>
                                <li>
                                    <a onClick={() => {
                                        if (browserCountry === 'GB' || loginconfig?.locale?.code === 'en_GB') {
                                            window.open("https://www.expedia.com/lp/b/terms-of-service?currency=USD&siteid=1", "_blank");
                                        } else {
                                            navigate(`/terms-conditions`);
                                        }
                                    }}>
                                        {T("Filters:Footer_Terms_Conditions")}
                                    </a>
                                </li>
                                <li className="copyright-10">
                                    <a>
                                        {T("Filters:Footer_Copyright")} © {new Date().getFullYear()}{" "}
                                        Genius®
                                    </a>
                                </li>
                            </ul>
                        </div>
                        </div>
                        {/* <div className="user-dropdown">
                            <FontAwesomeIcon icon={faArrowsRotate} className="refresh-icon" onClick={()=>window.location.reload()} />
                            <img src={GeniusMobile} alt={"genius"}/>
                        </div> */}
                        <div className="user-dropdown">
                            {/* <img src={BetaIcon} className="beta-icon" alt={"beta-icon"}/> */}
                            {/* <Dropdown> */}
                                {/* <Dropdown.Toggle onClick={() => handleClickOnLogo()}>
                                    <img src={GeniusMobile} alt={"genius"}/>
                                </Dropdown.Toggle> */}
                                {/* <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => navigate("/me/favorites")}>
                                        {T("Home:Home_My_Favourites")}
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={() => navigate("/me/settings")}>
                                        {T("Home:Home_Settings")}
                                    </Dropdown.Item>
                                    <Dropdown.Item className="btn-holder">
                                        <div className="auth-action">
                                            <a
                                                onClick={() =>
                                                    loginconfig.isLogin
                                                        ? navigate("/me/account")
                                                        : handleShowModal("register")
                                                }
                                            >
                                                {T("Buttons:Account")}
                                            </a>
                                        </div>
                                        <div className="auth-action">
                                            <a
                                                className="transparent-btn"
                                                onClick={() =>
                                                    loginconfig.isLogin
                                                        ? handleLogout()
                                                        : handleShowModal("login")
                                                }
                                            >
                                                {loginconfig?.isLogin ? T("Buttons:Logout") : T("Buttons:Login")}
                                            </a>
                                        </div>
                                    </Dropdown.Item>
                                </Dropdown.Menu> */}
                            {/* </Dropdown> */}
                        </div>
                        {/* Last in the row so it sits in the upper right corner, logo on the left */}
                        <a onClick={showMenuFun} className="menu-toggler">
                            <span className="bar1"></span>
                            <span className="bar2"></span>
                            <span className="bar3"></span>
                        </a>
                    </div>
                </nav>
            </header>
            <SignUpModal
                show={modals.register}
                onHide={() => handleHideModal("register")}
            />
            <SignInModal
                show={modals.login}
                onHide={() => handleHideModal("login")}
                showForgotModal={() => setShowForgotModal(true)}
            />
            <SuccessModal
                show={modals.confirmation}
                onHide={() => handleHideModal("confirmation")}
            />
            <ForgotPasswordModal
                show={showForgotModal}
                onHide={() => setShowForgotModal(false)}
            />
        </>
    );
};

AppHeader.propTypes = {
    setPageHandler: PropTypes.func,
    fetchPackages: PropTypes.bool,
}

export default AppHeader;
